export default __webpack_public_path__ + "images/assets/9496331459144118b5e75ee49999b13a.svg";